import { getFeatures } from "@q-food/q-food";

/**
 * Server-declared feature flags (`GET /api/features`).
 *
 * The AI features are opt-in on the server (`food.assistant.enabled` / `food.invoice-parser.enabled`,
 * both default `false`), and their endpoints answer `404` while off. Their entrypoints therefore have
 * to stay hidden unless the server says otherwise — an installation whose environment variables are
 * empty should show none of it.
 *
 * Everything defaults to `false` and a failed call leaves it that way, so the failure mode is hiding a
 * feature rather than offering one that cannot work.
 */
export const useFeaturesStore = defineStore("Features", () => {
	const assistant = ref(false);
	const invoiceParser = ref(false);
	const loaded = ref(false);

	async function load() {
		try {
			const features = await getFeatures();
			assistant.value = features.assistant === true;
			invoiceParser.value = features.invoiceParser === true;
		} catch {
			// An unreachable or older server means "no optional features", not "assume enabled".
			assistant.value = false;
			invoiceParser.value = false;
		} finally {
			loaded.value = true;
		}
	}

	return { assistant, invoiceParser, loaded, load };
});
